/// <amd-module name="VSS/Redux/Modules/TTIMonitor/TTIMonitorModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ITTIAwareState } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorContracts";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { monitorForActionValidation } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorSaga";
import { ttiMonitorReducer } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorReducer";
import { TTIMonitorActions } from "./TTIMonitorActions";

export function getTTIMonitorModule(splitTimingName?: string, serviceInstanceType?: string): ISagaModule<ITTIAwareState> {
    const reducerMap: ReducersMapObject<ITTIAwareState, AnyAction> = {
        ttiMonitorState: ttiMonitorReducer
    };

    return {
        id: "ttimonitor",
        reducerMap,
        sagas: [{ saga: monitorForActionValidation, argument: serviceInstanceType }],
        initialActions: splitTimingName ? [TTIMonitorActions.addSplit(splitTimingName)] : undefined
    };
}
